import { FC } from 'react';

import { CompaniesPageCategory } from '@constants_iqfu';

import styles from './HowToChooseCompanies.module.scss';
import PointData from './ranking_how_to_choose_companies_data.json';

type Props = {
  type: keyof typeof CompaniesPageCategory;
};

const HowToChooseCompanies: FC<Props> = ({ type }) => {
  return (
    <div className={styles.container}>
      <p className={styles.title}>{PointData[type].title}</p>
      <div className={styles.point_list_container}>
        <ul className={styles.point_list}>
          {PointData[type].points.map((point, index) => (
            <li key={index} className={styles.point}>
              <span>
                <img className={styles.itemize} src="/images/iqfu/public/middle_dot_gray.svg" alt="" />
              </span>
              <div dangerouslySetInnerHTML={{ __html: point }}></div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default HowToChooseCompanies;
